import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../store/hook";
import { useEffect, useRef, useState } from "react";
import { showAndHideSpinner } from "../../../../reducers/spinnerSlice";
import Dcs0301Service from "../../../../services/dcs/Dcs0301Service";
import { toast } from "react-toastify";
import { ExceptionConstant } from "../../../../constants/exceptionConstant";
import { TccoFileService } from "../../../../services/common/TccoFileService";
import Swal from "sweetalert2";

export default function AddProtocolForm(props: any) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [protocol, setProtocol] = useState<any>({});
  const [fileSlt, setFileSlt] = useState<any>(null);
  const [fileChange, setFileChange] = useState<any>(false);
  const [imagePreview, setImagePreview] = useState<any>(null);

  const fileRef = useRef<any>(null);

  useEffect(() => {
    if (props.data.protId) {
      getProtocolDetail();
    }
  }, []);

  useEffect(() => {
    if (protocol.imgId && props.data.isCreate) {
      create();
    }
    if (protocol.imgId && !props.data.isCreate && fileChange === true) {
      update();
    }
  }, [protocol.imgId]);

  const handleChange = (event: any) => {
    setProtocol({
      ...protocol,
      [event.target.name]: event.target.value,
    });
  };

  const getProtocolDetail = () => {
    Dcs0301Service.getInstance()
      .getProtocolDetail({ protocolId: props.data.protId })
      .then((res: any) => {
        setProtocol(res.data.responseData);
        setImagePreview(process.env.REACT_APP_VIEW_IMAGE_URL + `/${res.data.responseData.imgId}`);
      })
      .catch((err: any) => {});
  };

  function onSave(event: any) {
    event.preventDefault();
    if (chk(protocol)) {
      if (props.data.isCreate || (!props.data.isCreate && fileChange)) {
        dispatch(showAndHideSpinner(true));
        TccoFileService.getInstance()
          .saveFile(fileSlt)
          .then((res: any) => {
            setProtocol((prevState: any) => {
              return {
                ...prevState,
                imgId: res.data.responseData.atchFleSeq,
              };
            });
          })
          .catch((err: any) => {
            dispatch(showAndHideSpinner(false));
            toast.error(`${t("dcs0301.message.err.saveImg")}`);
          });
      } else {
        update();
      }
    }
  }

  const create = () => {
    Dcs0301Service.getInstance()
      .insertProtocol(protocol)
      .finally(() => {
        setTimeout(() => {
          dispatch(showAndHideSpinner(false));
        }, 500);
      })
      .then((resp) => {
        if (resp.data.status) {
          toast.success(`${t("dcs0301.message.success.save")}`);
          props.onClose(true);
        } else {
          if (resp.data.message === ExceptionConstant.PROTOCOL_EXISTED) {
            toast.error(`${t("dcs0301.message.err.protocolExisted")}`);
          } else {
            toast.error(`${t("dcs0301.message.err.save")}`);
          }
        }
      })
      .catch((error) => {
        toast.error(`${t("dcs0301.message.err.save")}`);
      });
  };

  const update = () => {
    Dcs0301Service.getInstance()
      .updateProtocol(protocol)
      .finally(() => {
        setTimeout(() => {
          dispatch(showAndHideSpinner(false));
        }, 500);
      })
      .then((resp) => {
        if (resp.data.status) {
          toast.success(`${t("dcs0301.message.success.update")}`);
          props.onClose(true);
        } else {
          if (resp.data.message === ExceptionConstant.PROTOCOL_EXISTED) {
            toast.error(`${t("dcs0301.message.err.protocolExisted")}`);
          } else {
            toast.error(`${t("dcs0301.message.err.update")}`);
          }
        }
      })
      .catch((error) => {
        toast.error(`${t("dcs0301.message.err.update")}`);
      });
  };

  function chk(params: any) {
    let _chk = true;
    if (params.protNm == null || params.protNm.trim() === "") {
      toast.error(`${t("dcs0301.required.message.protNm")}`);
      _chk = false;
    } else if (params.description == null || params.description.trim() === "") {
      toast.error(`${t("dcs0301.required.message.desc")}`);
      _chk = false;
    } else if (props.data.isCreate && fileSlt == null) {
      toast.error(`${t("dcs0301.required.message.image")}`);
      _chk = false;
    }

    if (!_chk) {
      setProtocol((prevState: any) => {
        return {
          ...prevState,
          protNm: prevState.protNm || "",
          description: prevState.description || "",
        };
      });
    }
    return _chk;
  }

  const handleUploadImage = () => {
    fileRef.current.click();
  };

  const handleFileChange = (e: any) => {
    let file = e.target.files[0];
    const imageUrl = URL.createObjectURL(file);

    setImagePreview(imageUrl);
    setFileSlt(file);
    setFileChange(true);
  };

  const deleteProtocol = () => {
    Swal.fire({
      title: t("dcs0201.message.dialog.confirmDelete"),
      showCancelButton: true,
      confirmButtonText: t("dcs0201.btn.delete"),
      cancelButtonText: t("dcs0201.btn.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(showAndHideSpinner(true));
        Dcs0301Service.getInstance()
          .delete(protocol)
          .then((result) => {
            dispatch(showAndHideSpinner(false));
            if (result.data.status) {
              toast.success(t("dcs0301.message.success.delete"));
              props.onClose(true);
            } else {
              toast.error(t("dcs0301.message.err.delete"));
            }
          });
      }
    });
  };

  return (
    <>
      <form onSubmit={onSave}>
        <div className="box">
          <div className="box-body">
            <div className="form-container">
              <div className="row align-items-center border-bottom">
                <div className="col-lg-3 form-label-grid">
                  <label htmlFor="validationProtNm" className="form-label">
                    {t("dcs0301.form.label.protNm")}
                    <strong className="strong-required"> *</strong>
                  </label>
                </div>
                <div className="col-lg-9">
                  <input value={protocol.protNm || ""} placeholder={t("dcs0301.form.placeholder.protNm")} className="form-control" name="protNm" id="validationProtNm" onChange={handleChange}></input>
                </div>
              </div>

              <div className="row align-items-center border-bottom">
                <div className="col-lg-3 form-label-grid" style={{ height: "128px" }}>
                  <label htmlFor="validationProtNm" className="form-label">
                    {t("dcs0301.form.label.desc")}
                    <strong className="strong-required"> *</strong>
                  </label>
                </div>
                <div className="col-lg-9">
                  <textarea
                    value={protocol.description || ""}
                    placeholder={t("dcs0301.form.placeholder.desc")}
                    rows={5}
                    className="form-control"
                    name="description"
                    id="validationDesc"
                    onChange={handleChange}></textarea>
                </div>
              </div>

              {/* <div className="row align-items-center border-bottom">
                <div className="col-lg-3 form-label-grid" style={{ height: "240px" }}>
                  <label htmlFor="validationProtNm" className="form-label">
                    {t("dcs0301.form.label.image")}
                    <strong className="strong-required"> *</strong>
                  </label>
                </div>
              </div> */}

              <div className="row align-items-center border-bottom">
                <div className="col-lg-3 form-label-grid" style={{ height: fileSlt || (!props.data.isCreate && protocol.imgId) ? "260px" : "auto" }}>
                  <label htmlFor="validationProtNm" className="form-label">
                    {t("dcs0301.form.label.image")}
                    <strong className="strong-required"> *</strong>
                  </label>
                </div>
                <div className="col-lg-9">
                  {(fileSlt || (!props.data.isCreate && protocol.imgId)) && (
                    <div className="mb-2">
                      <img
                        src={imagePreview}
                        onError={(e: any) => {
                          e.target.onerror = null;
                          e.target.src = require("../../../../../assets/images/no-img-avatar.png");
                        }}
                        alt="Preview"
                        style={{ width: "200px", height: "200px" }}
                      />
                    </div>
                  )}
                  <button type="button" className="custom-btn gradient" onClick={handleUploadImage}>
                    <i className="pi pi-plus me-2"></i> {t("common.button.label.uploadImg")}
                  </button>
                </div>
              </div>

              <div className="d-flex gap-3 mt-3 align-items-center justify-content-end">
                <button type="submit" className="custom-btn gradient">
                  <i className="pi pi-save fs-16 me-2"></i>
                  {t("confirm.button.save.text")}
                </button>
                {protocol.protStatus !== 1 && !props.data.isCreate && (
                  <button type="button" className="custom-btn danger" onClick={deleteProtocol}>
                    <i className="pi pi-trash fs-16 me-2"></i>
                    {t("sample.label.button.delete")}
                  </button>
                )}
                <button type="button" onClick={() => props.onClose(false)} className="custom-btn">
                  <i className="pi pi-times fs-16 me-2"></i>
                  {t("confirm.button.cancel.text")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <input type="file" ref={fileRef} accept="image/*" style={{ display: "none" }} onChange={handleFileChange} />
    </>
  );
}
